import React from 'react';
import { CSSObject } from 'styled-components';

import CustomScrollbars from '../../CustomScrollbar';
import { IDefaultPopup } from '../defaultPopup';

import * as ST from './styled';

export interface IBasePopup extends IDefaultPopup {
    title: string | JSX.Element,
    description?: string | JSX.Element,
    children: JSX.Element,
    customBasePopupStyles?: ST.IBasePopupCustomStyles,
    customDefaultPopupStyles?: CSSObject,
    customScrollBarStyles?: CSSObject,
}

const BasePopup = ({
    children,
    title,
    description,
    customBasePopupStyles,
    customDefaultPopupStyles,
    customScrollBarStyles,
    ...props
}: IBasePopup): JSX.Element => {
    const descIsString = typeof description === 'string';

    return (
        <ST.SDefaultPopup customStyles={customDefaultPopupStyles} {...props}>
            <ST.TopWrapper customStyles={customBasePopupStyles}>
                <ST.Title>{title}</ST.Title>
                {description
                    ? descIsString
                        ? <ST.Text>{description}</ST.Text>
                        : description
                    : null
                }
            </ST.TopWrapper>
            <ST.ContentWrapper customStyles={customBasePopupStyles}>
                <CustomScrollbars customStyles={customScrollBarStyles}>
                    <ST.ContentInner customStyles={customBasePopupStyles}>
                        {children}
                    </ST.ContentInner>
                </CustomScrollbars>
            </ST.ContentWrapper>
        </ST.SDefaultPopup>
    );
};

export default BasePopup;
